import React, {useState, useEffect} from 'react';
import { Container, Typography, Grid, Stack } from '@mui/material';
import EventOne from './events/EventOne';
import EventTwo from './events/EventTwo';
import EventThree from './events/EventThree';
import EventFour from './events/EventFour';
import EventFive from './events/EventFive';
import EventSix from './events/EventSix';
import EventSeven from './events/EventSeven';
import Skeleton from "@mui/material/Skeleton";
import { nanoid } from 'nanoid';
import axios from 'axios'
import { Navigation, Pagination, Autoplay } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import { useAppContext } from '../AppContext';
import { useTheme } from '@mui/material/styles';

const renderEventCard = (type, event) => {
  switch(type){
    case 1: return <EventOne data={event} disableButton={false} />;
    case 2: return <EventTwo data={event} disableButton={false} />;
    case 3: return <EventThree data={event} disableButton={false} />;
    case 4: return <EventFour data={event} disableButton={false} />;
    case 5: return <EventFive data={event} disableButton={false} />;
    case 6: return <EventSix data={event} disableButton={false} />;
    case 7: return <EventSeven data={event} disableButton={false} />;
    default: return <EventOne data={event} disableButton={false} />;
  };
};

export default function HomeEvents(props) {
  const [rEvents, setREvents] = useState(null)

  const theme = useTheme();
  const { url, themeData, siteData,  themeLoading, siteLoading, themeError, siteError, changeUrl, updateThemeData, updateSiteData } = useAppContext();
  const [themeCss, setThemeCss] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(()=>{
    let custom_css = themeData && themeData ? JSON.parse(themeData && themeData.custom_css): null;
    setThemeCss(custom_css)
    setLoading(false)
  }, [themeData]);

  useEffect(()=>{
      axios.get(
          `/api/events/similarEvents?eventId=${props.id}&clubId=${siteData&&siteData.club_inner[0].restaurantId}`, {
          headers: {
              "x-auth-token": process.env.JWT_TOKEN,
          },
      }).then((response) => {
          if (response.status == 200) {
              setREvents(response.data.result)
              setLoading(false);
          }
      })
  }, [props.id])
  
  const HomeEventsContainer = {
    py:{md:10, sm:7, xs:5},
    '& h2':{
      fontFamily: themeCss ? (themeCss.theme_primary_font).replace("+"," ") : '',
      fontSize:35,
      fontWeight:700,
      pb:5,
      color: theme.palette.primary.title
    }
  };

  let skeletonCards = Array(3).fill(0);
  return (
    <>
      <Container maxWidth="lg" sx={HomeEventsContainer}>
        {loading ? (
          <Grid container spacing={3}>
            {skeletonCards.map((index) => (
              <Grid item xs={12} sm={6} md={4} lg={4} xl={4} key={nanoid(30)}>
                <Skeleton
                  animation="wave"
                  variant="rectangular"
                  height={300}
                  sx={{ borderRadius: 0 }}
                />
                <Stack sx={{ mt: 3 }}>
                  <Skeleton
                    animation="wave"
                    variant="h3"
                    sx={{ color: "grey.900" }}
                  />
                </Stack>
                <Stack
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    flexDirection: "row",
                    mt: 3,
                    mb: 3,
                  }}
                >
                  <Skeleton
                    animation="wave"
                    width="40%"
                    variant="body1"
                    sx={{ color: "grey.900" }}
                  />
                  <Skeleton
                    animation="wave"
                    width="40%"
                    variant="body1"
                    sx={{ color: "grey.900" }}
                  />
                </Stack>
              </Grid>
            ))}
          </Grid>    
        ):(
          <>
          {rEvents && rEvents.length > 0 ? (
            <>
              <Typography variant="h2">You May Like</Typography>
              <Typography component="div">
                  <Swiper
                    modules={[Navigation, Pagination, Autoplay]}
                    spaceBetween={20}                                                   
                    navigation                        
                    autoplay={true}
                    loop={true}
                    slidesPerView={1.25}
                    breakpoints={{
                      768: {
                          width: 768,
                          slidesPerView: 2,
                      },
                      425: {
                          width: 425,
                          slidesPerView: 1.25,
                      },
                    }}
                  >
                    {/* <Grid container spacing={3}> */}
                      {rEvents && rEvents.map((event) => (
                        <SwiperSlide nanoid={30}>
                          {
                          siteData && siteData.sections[0].events_type == 1 || 
                          siteData && siteData.sections[0].events_type == 2 || 
                          siteData && siteData.sections[0].events_type == 3 ||
                          siteData && siteData.sections[0].events_type == 4 ||
                            siteData && siteData.sections[0].events_type == 5 ? (
                              <Grid item xs={12} sm={12} md={4} lg={4} xl={4}>
                                {renderEventCard(siteData && siteData.sections[0].events_type, event)}
                              </Grid>
                          ):(
                            <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                              {renderEventCard(siteData && siteData.sections[0].events_type, event)}
                            </Grid>
                          )}
                          </SwiperSlide>
                      ))}
                    {/* </Grid> */}
                  </Swiper>
              </Typography>
            </>
          ):('')}
          </>
        )}
      </Container>
    </>
  );
}
